export default {
  common: {

  },
  pending: {
    table: {
      timeHeader: 'Time',
      systemIdHeader: 'System Id',
      productIdHeader: 'Product Id',
      ipAddressHeader: 'IP Address',
      declinedHeader: 'Declined',
      emptyMessage: 'No pending product instances to display'
    },
    provisionTable: {
      header: 'Provision Product Instance',
      provisionAction: 'Provision',
      declineAction: 'Decline'
    },
    provisionSystemInformation: {
      title: 'System Information',
      systemIdLabel: 'System Identifier',
      productIdLabel: 'Product',
      productVersionLabel: 'Version',
      descriptionLabel: 'Description',
      systemIdPlaceholder: 'System Identifier',
      productIdPlaceholder: 'Product',
      productVersionPlaceholder: 'Version',
      descriptionPlaceholder: 'Description'
    },
    provisionLocation: {
      title: 'Where is this?',
      customerLabel: 'Customer',
      locationLabel: 'Location',
      customerPlaceholder: 'Customer',
      locationPlaceholder: 'Location',
      orLabel: 'OR'
    },
    provisionLease: {
      title: 'Lease Information',
      jurisdictionLabel: 'Jurisdiction',
      systemStatusLabel: 'System Status',
      paidThroughLabel: 'Paid Through',
      jurisdictionPlaceholder: 'Jurisdiction',
      systemStatusPlaceholder: 'System Status',
      paidThroughPlaceholder: 'Paid Through (Date & Time)'
    },
    provision: {
      title: 'Provision Product',
      saveAction: 'Save',
      cancelAction: 'Cancel'
    }
  },
  productInstance: {
    modify: {
      freeTextEnable: 'Enable Free Text',
      freeTextDisable: 'Disable Free Text',
      customerOptionGroupLabel: 'Customers',
      locationOptionGroupLabel: 'Locations',
      locationLabel: 'Location/Customer',
      systemIdentifierLabel: 'System Identifier',
      productVersionLabel: 'Version',
      descriptionLabel: 'Description',
      systemStatusLabel: 'System Status',
      paidThroughLabel: 'Paid Through',
      locationPlaceholder: 'Location/Customer',
      systemIdentifierPlaceholder: 'System Identifier',
      productVersionPlaceholder: 'Version',
      descriptionPlaceholder: 'Description',
      systemStatusPlaceholder: 'System Status',
      paidThroughPlaceholder: 'Paid Through (Date & Time)',
      saveAction: 'Save',
      cancelAction: 'Cancel',
      pushAction: 'Push'
    },
    table: {
      parentHeader: 'Parent',
      productHeader: 'Product',
      systemIdentifierHeader: 'System ID',
      descriptionHeader: 'Description',
      versionHeader: 'Version',
      jurisdictionHeader: 'Jurisdiction',
      statusHeader: 'Status',
      paidThroughHeader: 'Paid Through',
      lastAuthorizedHeader: 'Last Authorized',
      emptyMessage: 'No product instances to display'
    },
    modifyTable: {
      header: 'Product Instance',
      disableBatchAction: 'Enable Single Mode',
      enableBatchAction: 'Enable Batch Mode',
      provisionAction: 'Provision',
      filterPlaceholder: 'Search'
    }
  },
  customer: {
    modifyLegal: {
      title: 'Legal Information',
      parentUuidLabel: 'Customer',
      parentUuidPlaceholder: 'Customer',
      nameLabel: 'Name',
      namePlaceholder: 'Name',
      regulatoryLicenseLabel: 'License',
      regulatoryLicensePlaceholder: 'License'
    },
    modifyAddress: {
      title: 'Address',
      line1Label: 'Line 1',
      line1Placeholder: 'Line 1',
      line2Label: 'Line 2',
      line2Placeholder: 'Line 2',
      cityLabel: 'City',
      cityPlaceholder: 'City',
      zipLabel: 'Zip',
      zipPlaceholder: 'Zip',
      stateLabel: 'State',
      statePlaceholder: 'State',
      countryLabel: 'Country',
      countryPlaceholder: 'Country'
    },
    modify: {
      saveAction: 'Save',
      cancelAction: 'Cancel'
    },
    modifyTree: {
      createCustomerAction: '',
      createLocationAction: ''
    }
  },
  user: {
    table: {
      activeHeader: 'Active',
      userNameHeader: 'User Name',
      firstNameHeader: 'First Name',
      lastNameHeader: 'Last Name',
      emptyMessage: 'No users to display'
    },
    modifyTable: {
      header: 'Users',
      addAction: 'Add',
      filterPlaceholder: 'Search'
    },
    modify: {
      userNameLabel: 'User Name',
      userNamePlaceholder: 'User Name',
      firstNameLabel: 'First Name',
      firstNamePlaceholder: 'First Name',
      lastNameLabel: 'Last Name',
      lastNamePlaceholder: 'Last Name',
      activeLabel: 'Active',
      saveAction: 'Save',
      cancelAction: 'Cancel',
      changePasswordAction: 'Change password...'
    },
    create: {
      title: 'Create User',
      userNameLabel: 'E-mail Address',
      userNamePlaceholder: 'E-mail Address',
      firstNameLabel: 'First Name',
      firstNamePlaceholder: 'First Name',
      lastNameLabel: 'Last Name',
      lastNamePlaceholder: 'Last Name',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Password',
      passwordRepeatedLabel: 'Repeat Password',
      passwordRepeatedPlaceholder: 'Repeat Password',
      saveAction: 'Save',
      cancelAction: 'Cancel'
    },
    updatePassword: {
      title: 'Update Password',
      currentPasswordLabel: 'Current Password',
      currentPasswordPlaceholder: 'Current Password',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Password',
      passwordRepeatedLabel: 'Repeat Password',
      passwordRepeatedPlaceholder: 'Repeat Password',
      saveAction: 'Save',
      cancelAction: 'Cancel'
    }
  },
  comm: {
    table: {
      header: 'Communication Channels',
      emptyMessage: 'No items to display',
      parentHeader: 'Parent',
      productHeader: 'Product',
      nameHeader: 'Name',
      ageHeader: 'Age',
      activeHeader: 'Comm Status',
      depthHeader: 'Depth',
      numberOfEmptyReceivesHeader: 'Empty Receives',
      ageYoung: 'Young',
      ageNotYoung: 'Not Young',
      active: 'Active',
      inactive: 'Inactive',
      statusHeader: 'App Status',
      status: {
        unknown: 'Waiting',
        ACTIVE: 'Active',
        STARTED: 'Started',
        STOPPING: 'Stopping',
        UPDATING: 'Updating'
      }
    }
  },
  report: {
    header: 'Reporting'
  },
  product: {
    table: {
      header: 'Applications',
      uuidHeader: 'UUID',
      packageHeader: 'Package',
      nameHeader: 'Name',
      emptyMessage: 'No applications to display'
    },
    permissions: {
      header: 'Application Permissions',
      keyHeader: 'Key',
      defaultValueHeader: 'Default Value',
      cascadingHeader: 'Cascading',
      emptyMessage: 'No permissions to display'
    },
    versions: {
      header: 'Application Versions',
      versionHeader: 'Version',
      timestampHeader: 'Timestamp',
      md5Header: 'MD5',
      statusHeader: 'Status',
      emptyMessage: 'No versions to display'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/translations/en.js